import { Clear as ClearIcon, FileDownload as ExportIcon, NotificationsActive as BellIcon } from '@mui/icons-material'
import { Box, Button, Chip, Tooltip, IconButton } from '@mui/material'
import { GridFilterModel } from '@mui/x-data-grid-pro'
import React from 'react'

interface FeedbackGridToolbarProps {
	filterModel: GridFilterModel
	onClearFilters: () => void
	onExport: () => void
	exporting: boolean
	translations: Record<string, string>
	isAdmin?: boolean
	selectedCount?: number
	onTestNotification?: () => void
	testingNotification?: boolean
}

export const FeedbackGridToolbar: React.FC<FeedbackGridToolbarProps> = ({
	filterModel,
	onClearFilters,
	onExport,
	exporting,
	translations,
	isAdmin = false,
	selectedCount = 0,
	onTestNotification,
	testingNotification = false,
}) => {
	return (
		<Box
			className="MuiDataGrid-toolbarContainer"
			sx={{ display: 'flex', justifyContent: 'space-between', p: 1, alignItems: 'center' }}
		>
			<Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
				{filterModel.items.length > 0 && (
					<Button
						variant="contained"
						size="small"
						startIcon={<ClearIcon />}
						onClick={onClearFilters}
						sx={{ height: 32 }}
						className="!bg-primary"
					>
						{translations.clearFilters || 'Clear Filters'}
					</Button>
				)}
				{isAdmin && selectedCount > 0 && (
					<Button
						variant="contained"
						color="error"
						size="small"
						startIcon={<BellIcon />}
						onClick={onTestNotification}
						disabled={testingNotification}
						sx={{ height: 32 }}
						endIcon={
							<Chip
								label={selectedCount}
								size="small"
								sx={{ bgcolor: 'error.dark', color: 'white', height: 18, fontSize: 11 }}
							/>
						}
					>
						{translations.testNotification || 'Test Notification'}
					</Button>
				)}
			</Box>
			<Tooltip title={translations.exportToCsv || 'Export to CSV'}>
				<IconButton onClick={onExport} disabled={exporting} size="small">
					<ExportIcon />
				</IconButton>
			</Tooltip>
		</Box>
	)
}
